import { StrictMode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { miniApp, retrieveLaunchParams } from '@telegram-apps/sdk-react';
import { createRoot } from 'react-dom/client';
import '@utils/i18n.util.js';
import '@styles/index.style.css';
import ErrorBoundaryComponent from '@components/ErrorBoundary.component.jsx';
import { errorLogger } from '@utils/errorLogger.util.js';
import { initSentry, sentryConfig } from '@utils/initSentry.util.js';
import { initTelegram } from '@utils/initTelegram.util.js';
import { initTagManager } from '@utils/tagManager.util.js';
import App from './App.jsx';

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer, sentryConfig);

initSentry();
initTagManager();

// TODO: привести в нормальный вид
try {
  initTelegram()
    .then(() => miniApp.ready())
    .then(() => {
      root.render(
        <ErrorBoundary
          fallback={<ErrorBoundaryComponent />}
          onError={(error) =>
            errorLogger.error(error, { source: 'ErrorBoundary' })
          }
        >
          <StrictMode>
            <App />
          </StrictMode>
        </ErrorBoundary>,
      );
    })
    .catch((error) => {
      let details = {};

      if (error.message === 'ERR_NOT_SUPPORTED') {
        const { tgWebAppPlatform, tgWebAppVersion } = retrieveLaunchParams();

        details = {
          ...details,
          tgWebAppPlatform,
          tgWebAppVersion,
        };
      }

      errorLogger.error(error, {
        source: 'TelegramInitialization',
        ...details,
      });
      root.render(<ErrorBoundaryComponent errorType={error.message} />);
    });
} catch (error) {
  errorLogger.error(error, { source: 'Main' });
  root.render(<ErrorBoundaryComponent />);
}
